import Typography from "@mui/material/Typography";

/**
 * Mark for a contact-data provider (`DataProvider.provider`), shown in a
 * `LogoBadge`: the provider's initials, so any provider the backend registers
 * renders without a frontend change.
 */
export default function DataProviderLogo({ name, size = 40 }: { name: string; size?: number }) {
  // "GetLeads" → "GL", "Clay" → "C": capitals first, else the first letter.
  const capitals = name.replace(/[^A-Z]/g, "");
  const initials = (capitals.length >= 2 ? capitals.slice(0, 2) : name.slice(0, 1)).toUpperCase();
  return (
    <Typography
      component="span"
      aria-label={name}
      sx={{
        fontWeight: 700,
        fontSize: size * (initials.length > 1 ? 0.36 : 0.45),
        lineHeight: 1,
        letterSpacing: "-0.02em",
        color: "text.primary",
      }}
    >
      {initials}
    </Typography>
  );
}
